import React, { useEffect, useState } from 'react';
import './SplashScreen.css';

function SplashScreen({ onFinish }) {
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Set timeout to hide splash screen after 2.2 seconds
        const timer = setTimeout(() => {
            setIsVisible(false);
            if (onFinish) {
                onFinish();
            }
        }, 2500);

        return () => clearTimeout(timer);
    }, [onFinish]);

    const [progress, setProgress] = useState(0);

    
    useEffect(() => {
    // Add a delay to the progress logic
    const startTimeout = setTimeout(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                const nextProgress = prevProgress + 1;
                if (nextProgress >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return nextProgress;
            });
        }, 12);
        
        return () => clearInterval(interval);
    }, 1000); // Wait 1 second before starting the "fill"

    return () => clearTimeout(startTimeout);
}, []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className="splash-screen" style={{ display: 'grid', placeItems: 'center' }}>
            <div className="pulse-circle" style={{ gridRow: '1', gridColumn: '1' }}></div>
            <div className="pulse-circle pulse-circle2" style={{ gridRow: '1', gridColumn: '1' }}></div>
            <div className="splash-container" style={{ gridRow: '1', gridColumn: '1', zIndex: 1 }}>
                <img src="/assets/images/logo.svg" alt="logo" className="splash-logo" />
                <p className="splash-text">Construction Consultancy</p>
                <div className="progress-bar-container">
                    {/* The width of this 'filler' div represents the completed portion. */}
                    <div
                        className="progress-bar-filler"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
            </div>
        </div>
    );
}

export default SplashScreen;
